"use strict";

class StationSettingsStringsCtrl {
    constructor($rootScope, $http, $mdToast, $mdDialog, $state, $transitions) {
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.status = {saving: false, errors: false};
        this.strings = [];
        this.fetch();

        this.isSaved = false;
        this.firstVisit = true;

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        this.unregisterStateChangeStart = $transitions.onStart({ }, this.stateChangeStart.bind(this));

    }

    stateChangeStart(transition) {

        let to = transition.to();
        let toParams = transition.params();

        if (!angular.equals(this.copyString, this.currentString) && this.isSaved == false) {
            transition.abort();
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: "unsavedDataDialog.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            }).then(() => {
                this.isSaved = true;
                this.$state.go(to, toParams);
            });
        }
    }

    fetch() {
        this.strings = [];
        this.$http.get('/station/strings').then(response => {
            this.strings = response.data;

            if (this.$state.params.stringId) {

                this.currentString = this.strings[this.$state.params.stringId];
                this.currentIndex = this.$state.params.stringId;

                this.render(this.strings[this.$state.params.stringId]);

                this.copyString = angular.copy(this.currentString);
            }
        });
    }

    save() {
        if (this.currentString.id) {
            this.$http.put('/station/strings', this.currentString)
                .then(() => {
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.object_saved?object=Text', //@trans('labels.settings')
                        hideDelay: 6000,
                        position: ('top right')
                    });

                    this.fetch();

                    this.isSaved = true;

                });
        } else {
            this.$http.post('/station/strings', this.currentString)
                .then(() => {
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.object_saved?object=Text', //@trans('labels.settings')
                        hideDelay: 6000,
                        position: ('top right')
                    });

                    this.fetch();

                    this.isSaved = true;

                });
        }

        this.fetch();

    }

    render(content) {
        if (content) {
            this.$http.post('station/twigpreview', content)
                .then((render) => {
                    this.renderPreview = render.data;
                });
        }
    }

    addString() {
        let indexContent = {
            name: 'string',
            content: `{{ station.name }} - {{ station.pay_off }} - {% if item %}{{ item.title }} - {% endif %}You are listening to: {{ broadcast.title -}}
{% if item.contacts %}
 - Now in the {{ station.name }} studio: {% for contact in item.contacts %}
{{ contact.firstname }} {{ contact.lastname -}}
{% if item.contacts|length > 1 %},{% endif %}
{% endfor %}{% endif %}
 - The time is: {{ "now"|date("H:i") }} on {{ "now"|date("d-m-Y") }}`
        };

        if (this.isSaved == false && this.firstVisit == false) {
            event.preventDefault();
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: "unsavedDataDialog.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            }).then(() => {
                let length = this.strings.push(indexContent);

                this.openString(length - 1);

                this.isSaved = false;
            });
        } else {
            let length = this.strings.push(indexContent);

            this.openString(length - 1);

            this.isSaved = false;
            this.firstVisit = false;
        }
    }

    openString(index) {

        this.currentString = this.strings[index];
        this.currentIndex = index;

        this.copyString = angular.copy(this.currentString);

        this.$state.transitionTo('stationsettings.visuals_strings.strings.string', {stringId: index});

        this.render(this.strings[index]);

    }

    checkActiveString(index) {
        return this.$state.params.stringId == index;
    }

    sanitizeStringName() {
        if (this.currentString.name) {
            this.currentString.name = this.currentString.name.trim().replace(/[^\w\d_]/gi, '').toLowerCase();
        }
    }

    destroy(string, ev, index) {
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            //parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {
            if (string.id) {
                this.$http.delete('/station/strings/' + string.id);
            }

            this.strings.splice(index, 1);

            if (this.currentIndex === index) {
                this.$state.transitionTo('stationsettings.visuals_strings.strings');
            }
        });
    }

    openMenu($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    }
}


StationSettingsStringsCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$mdDialog', '$state', '$transitions'];


module.exports = StationSettingsStringsCtrl;
